@if (productData$ | async; as productData) {
  @if (
    productData.baseOptions &&
    productData.baseOptions[0] &&
    productData.baseOptions[0].options &&
    productData.baseOptions[0].options.length > 1
  ) {
    <div class="containerSpacing">
      <div>
        <span>
          {{ 'productDetails.labelVariantDropdown' | transloco }}
        </span>
      </div>
      @if (componentData.data$ | async; as componentData) {
        <div class="custom-variant-container">
          <ng-select
            [searchable]="false"
            [clearable]="false"
            [items]="productData.baseOptions[0].options"
            [(ngModel)]="selectedVariant"
            [markFirst]="false"
          >
            <!-- Selected variant -->
            <ng-template ng-label-tmp let-item="item" let-clear="clear">
              <boels-product-variant-selector-list-item
                [variantOption]="selectedVariant"
              ></boels-product-variant-selector-list-item>
            </ng-template>
            <!-- Variant options -->
            <ng-template ng-option-tmp let-item="item" let-index="index">
              @if (item.variantOptionQualifiers) {
                <a
                  [cmsRouterLink]="item.url"
                  [product]="productData"
                  [productIndex]="index"
                  [componentName]="componentData.uid || ''"
                  [variantName]="item.variantOptionQualifiers[0].value"
                  boelsDataDm
                >
                  <boels-product-variant-selector-list-item
                    [variantOption]="item"
                  ></boels-product-variant-selector-list-item>
                </a>
              }
            </ng-template>
          </ng-select>
        </div>
      }
    </div>
  }
}
